import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root',
})
export class IdentityProviderHttpService extends BaseHttpService {
  private baseURL = `superadmin/identity-providers`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public searchIdentityProviders(queryParams: Record<string, string>) {
    return this.list(this.routerService.mount(this.baseURL), queryParams);
  }

  public getIdentityProvider(identityProviderId: number) {
    return this.read(this.routerService.mount(`${this.baseURL}/${identityProviderId}`));
  }

  public createIdentityProvider(body: unknown) {
    return this.create(body, this.routerService.mount(this.baseURL));
  }

  public updateIdentityProvider(identityProviderId: number, body: unknown) {
    return this.update(body, this.routerService.mount(`${this.baseURL}/${identityProviderId}`));
  }

  public deleteIdentityProvider(identityProviderId: number) {
    return this.delete(this.routerService.mount(`${this.baseURL}/${identityProviderId}`));
  }
}
